// extracted by mini-css-extract-plugin
export var numpadContainer = "_q0-1";
export var phoneButton = "_q0-0";